import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSession from 'vue-session'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'normalize.css';
import '@/styles/app.css';
// import '@/styles/senco/app.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import vueDebounce from 'vue-debounce';

Vue.use(vueDebounce);
Vue.use(VueSession, {persist: true});
Vue.config.productionTip = false;
Vue.config.silent = true;

const prod = process.env.NODE_ENV === 'production';
const shouldSW = 'serviceWorker' in navigator && prod;

const swRegistration = Vue.observable({swRegistration: null});
Object.defineProperty(Vue.prototype, '$swRegistration', {
  get() {
    return swRegistration.swRegistration;
  },
  set(value) {
    swRegistration.swRegistration = value;
  }
});

const page = Vue.observable({page: null});
Object.defineProperty(Vue.prototype, '$page', {
  get() {
    return page.page;
  },
  set(value) {
    page.page = value;
  }
});

const questionnaire = Vue.observable({questionnaire: null});
Object.defineProperty(Vue.prototype, '$questionnaire', {
  get() {
    return questionnaire.questionnaire;
  },
  set(value) {
    questionnaire.questionnaire = value;
  }
});

const alert = Vue.observable({alert: null});
Object.defineProperty(Vue.prototype, '$alert', {
  get() {
    return alert.alert;
  },
  set(value) {
    alert.alert = value;
  }
});

const authenticated = Vue.observable({authenticated: null});
Object.defineProperty(Vue.prototype, '$authenticated', {
  get() {
    return authenticated.authenticated;
  },
  set(value) {
    authenticated.authenticated = value;
  }
});

const company = Vue.observable({company: null});
Object.defineProperty(Vue.prototype, '$company', {
  get() {
    return company.company;
  },
  set(value) {
    company.company = value;
  }
});

const appVersion = Vue.observable({appVersion: null});
Object.defineProperty(Vue.prototype, '$appVersion', {
  get() {
    return appVersion.appVersion;
  },
  set(value) {
    appVersion.appVersion = value;
  }
});

const nav_history = Vue.observable({nav_history: []});
Object.defineProperty(Vue.prototype, '$nav_history', {
  get() {
    return nav_history.nav_history;
  },
  set(value) {
    nav_history.nav_history.push(value);
  }
});

const newWorker = Vue.observable({newWorker: null});
Object.defineProperty(Vue.prototype, '$newWorker', {
  get() {
    return newWorker.newWorker;
  },
  set(value) {
    newWorker.newWorker = value;
  }
});

const update = Vue.observable({update: null});
Object.defineProperty(Vue.prototype, '$update', {
  get() {
    return update.update;
  },
  set(value) {
    update.update = value;
  }
});

const saveIOSToken = Vue.observable({saveIOSToken: null});
Object.defineProperty(Vue.prototype, '$saveIOSToken', {
  get() {
    return saveIOSToken.saveIOSToken;
  },
  set(value) {
    saveIOSToken.saveIOSToken = value;
  }
});

const subscription = Vue.observable({subscription: null});
Object.defineProperty(Vue.prototype, '$subscription', {
  get() {
    return subscription.subscription;
  },
  set(value) {
    subscription.subscription = value;
  }
});

const updateShow = Vue.observable({updateShow: null});
Object.defineProperty(Vue.prototype, '$updateShow', {
  get() {
    return updateShow.updateShow;
  },
  set(value) {
    updateShow.updateShow = value;
  }
});

Vue.prototype.$newWorker = null;
Vue.prototype.$update = false;
Vue.prototype.$updateShow = false;

let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

let swlink = shouldSW ? 'service-worker.js' : 'static/service-worker.js';
if(isSafari || navigator.userAgent.indexOf('iPhone') > -1  || navigator.userAgent.indexOf('Macintosh') > -1 || navigator.userAgent.indexOf('iPad') > -1) {
  // console.log('safari or iPhone');
} else {
  // console.log('load SW');
  navigator.serviceWorker.register(swlink).then((swReg) => {
    Vue.prototype.$swRegistration = swReg;

    swReg.addEventListener('updatefound', () => {
      // A wild service worker has appeared in reg.installing!
      Vue.prototype.$newWorker = swReg.installing;

      Vue.prototype.$newWorker.addEventListener('statechange', () => {
        // Has network.state changed?
        switch (Vue.prototype.$newWorker.state) {
          case 'installed':
            if (navigator.serviceWorker.controller) {
              // new update available
              Vue.prototype.$update = true;
            }
            // No update available
            break;
        }
      });
    });
  })


  let refreshing;
  // The event listener that is fired when the service worker updates
  // Here we reload the page
  navigator.serviceWorker.addEventListener('controllerchange', function () {
    // console.log('controllerchange');
    if (refreshing) return;
    if(Vue.prototype.$update) {
      Vue.prototype.$updateShow = true;
    }
    refreshing = true;
  });
}

Vue.prototype.$company = {
  'name': 'evotivate',
  'url': process.env.API_URL,
  'urlAbout': process.env.API_URL + '/#about',
  'urlLegal': process.env.API_URL + '/legal',
  'urlTerms': process.env.API_URL + '/terms',
  'urlContact': process.env.API_URL + '/#order',
  'urlPrivacy': process.env.API_URL + '/privacy-policy',
  'urlSignup': process.env.API_URL + '/#order'
};

Vue.prototype.$appVersion = '1';
Vue.prototype.$page = 'Home';
Vue.prototype.$authenticated = false;
Vue.prototype.$nav_history.push('Home');
Vue.prototype.$saveIOSToken = null;
Vue.prototype.$subscription = null;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})

Vue.mixin({
  methods: {
    goBack: function () {
      this.setPage(Vue.prototype.$nav_history[(Vue.prototype.$nav_history.length - 2)]);
      Vue.prototype.$nav_history.pop();
    },
    setHistory: function (component) {
      if (Vue.prototype.$nav_history[(Vue.prototype.$nav_history.length - 1)] !== component) {
        Vue.prototype.$nav_history = component;
      }
    },
    setPage: function (page) {
      Vue.prototype.$page = page;
    },
    showAlert: function (alert) {
      Vue.prototype.$alert = alert;
    },
    logout: function () {
      // console.log('logout')
      this.$authenticated = false;
      this.$session.remove('token');
      this.$session.remove('id');
      this.$router.replace({name: "Login"});
      location.reload();
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js